"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function SET_APRIL_CRUISES(state, cruises) {
    state.aprilCruises = cruises;
}
exports.SET_APRIL_CRUISES = SET_APRIL_CRUISES;
function SET_APRIL_CRUISES_IDS(state, cruiseIds) {
    state.aprilCruiseIds = cruiseIds;
}
exports.SET_APRIL_CRUISES_IDS = SET_APRIL_CRUISES_IDS;
function SET_CAROL_CAMPAIGN(state, data) {
    state.carolCampaign = data;
}
exports.SET_CAROL_CAMPAIGN = SET_CAROL_CAMPAIGN;
function SET_FILTER_DURATION(state, duration) {
    state.filter.travelDuration = duration;
}
exports.SET_FILTER_DURATION = SET_FILTER_DURATION;
function SET_FILTER_REGION(state, region) {
    state.filter.region = region;
}
exports.SET_FILTER_REGION = SET_FILTER_REGION;
function SET_FILTER_TIME_FROM(state, timeFrom) {
    state.filter.timeFrom = timeFrom;
}
exports.SET_FILTER_TIME_FROM = SET_FILTER_TIME_FROM;
function SET_FILTER_TIME_TO(state, timeTo) {
    state.filter.timeTo = timeTo;
}
exports.SET_FILTER_TIME_TO = SET_FILTER_TIME_TO;
function SET_PRICE_MODEL(state, priceModel) {
    state.priceModel = priceModel;
}
exports.SET_PRICE_MODEL = SET_PRICE_MODEL;
function SET_PRICEPLANCODES(state, pricePlanCodes) {
    state.pricePlanCodes = pricePlanCodes;
}
exports.SET_PRICEPLANCODES = SET_PRICEPLANCODES;
function SET_TEASER_OFFERS(state, teaserOffers) {
    state.teaserOffers = teaserOffers;
}
exports.SET_TEASER_OFFERS = SET_TEASER_OFFERS;
function SET_TEASER_OFFERS_REDUCED(state, reducedTeaserOffers) {
    state.teaserOffersReduced = reducedTeaserOffers;
}
exports.SET_TEASER_OFFERS_REDUCED = SET_TEASER_OFFERS_REDUCED;
function SET_TIMESTAMP(state, timeStamp) {
    state.timeStamp = timeStamp;
}
exports.SET_TIMESTAMP = SET_TIMESTAMP;
function SET_TIMING_STATES(state, timingStates) {
    state.timingStates = timingStates;
}
exports.SET_TIMING_STATES = SET_TIMING_STATES;
function RESET_STATE(state) {
    state.teaserOffers = [
        {
            amenities: [
                {
                    amount: 0,
                    description: '',
                    id: '',
                    type: '',
                },
            ],
            bookableUntil: '',
            cabinCategoryOffer: {
                code: '',
                image: '',
                name: '',
            },
            cheapestCruiseIndex: 0,
            cheapestPrice: 0,
            cruises: [],
            duration: 0,
            endPort: '',
            itineraryId: '',
            portImage: {
                alt: {},
                file: '',
                keywords: [],
                uid: '',
            },
            priceInfo: {
                amount: 0,
                priceModel: '',
                surcharges: [],
            },
            regionIds: [],
            routeName: '',
            startPort: '',
        },
    ];
    state.carolCampaign = {
        campaignEnd: '',
        campaignStart: '',
        campaignTeaserPricesStart: '',
        contentSections: [],
        contentSectionsHeadline: '',
        createdAt: '',
        description: '',
        descriptionHtml: '',
        headerImage: {
            alt: {},
            file: '',
            keywords: [],
            uid: '',
        },
        headline: '',
        id: '',
        specialOffers: [],
        subHeadline: '',
        tariffInformationDescription: '',
        tariffInformationDescriptionHtml: '',
        tariffInformationHeadline: '',
        teaserImage: {
            alt: {},
            file: '',
            keywords: [],
            uid: '',
        },
        updatedAt: '',
    };
    state.filter = {
        region: 'NONE',
        timeFrom: '',
        timeTo: '',
        travelDuration: 9999,
    };
}
exports.RESET_STATE = RESET_STATE;
//# sourceMappingURL=mutations.js.map